import React from 'react';
import { Handle, Position } from 'reactflow';
import './nodes.css';

const GironeNode = ({ data, selected }) => (
  <div className={`fnode fnode--girone ${selected ? 'is-selected' : ''}`}>
    <Handle type="target" position={Position.Left} />
    <div className="fnode__title">{data.name || 'Girone'}</div>
    <Handle type="source" position={Position.Right} />
  </div>
);

export default GironeNode;
